module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABIklEQVQ4T6WTMU7DQBBF/98tOAAVFwA7lIiCjig2HZS0nCAOFCmoCOIAgNNRQQWCA4CwJSLR0scRF0DKAWjsHbQWtoKxhIWnW83Mm/kzs0RLo833w+QNwEbOEjxEA2e/yu2F7x1Fcw+R9W/fJAqcbgEQQG9bhzbZx9OhM6trzDuf5jHWqPkSBQ5LgH00VWNBVYCldZsCehezTUUZWql5VUuMj9xJAfAupyOCHRBbAFIAr4A8RoF7Wy3yq21vPDuhyC5FrqD0EozMobAiImekOn7ur44XIT8ARbJK051M64DgAYllk8meovkUpe9E5CYeuKNymIu0RgDyOu6vndYC8nlUJGRG5vovCa2H6IdJuzX6YSJtD6k9oNzGfz5T0xOui/sC3UCzEW/vr2wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gateway/yl.png
// module id = 780
// module chunks = 137